export default __webpack_public_path__ + "static/media/audio/cannon-missfire.42ecc5779a274ac2a69f7db78f2b8440.mp3";